"use client"

import React from "react"

import { ACTIVITIES_URI, MobileTabs, USER_HOME_URI } from "@bullseye/components"

const MobileNav = () => {
  return (
    <MobileTabs
      items={[
        {
          icon: "home",
          titleKey: "navigation.home",
          title: "Home",
          uri: USER_HOME_URI,
        },
        {
          icon: "explore",
          titleKey: "navigation.explore",
          title: "Activities",
          uri: ACTIVITIES_URI,
        },
      ]}
    />
  )
}

export default MobileNav
